module.exports = __webpack_public_path__ + "img/warning_yellow.fe304396.svg";